import type { JSX } from 'react';
import React from 'react';

import type { IPerson } from '@feathr/blackbox';

import SelectOption from '../SelectOption';
import type { ISelectOptionProps } from '../SelectOptions.types';
import PersonContents from './PersonContents';

function PersonOption<T extends IPerson>(props: Readonly<ISelectOptionProps<T>>): JSX.Element {
  const { data } = props;

  return (
    <SelectOption {...props}>
      <PersonContents data={data} size={'medium'} />
    </SelectOption>
  );
}

export default PersonOption;
